import React, { useEffect, useState } from "react";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BreadCrumbDiv from "../../components/common/BreadCrumbDiv";
import ListWrapDiv from "../../components/common/ListWrapDiv";
import SearchInput from "../../components/common/SearchInput";
import ButtonWrapDiv from "../../components/common/ButtonWrapDiv";
import FunctionButton from "../../components/common/FunctionButton";
import MessageDialog from "../../components/common/MessageDialog";

const CheckPwdPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [pwd, setPwd] = useState("");

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  useEffect(() => {
    if (!JSON.parse(sessionStorage.getItem("userInfo")).userId) {
      navigate("/login");
    }
  }, []);

  const handlePwdChange = (e) => {
    setPwd(e.target.value);
  };

  const activeEnter = (e) => {
    if (e.key === "Enter") {
      handleSubmit();
    }
  };

  const handleConfirm = () => {
    setIsDialogOpen(false);
  };

  const handleSubmit = () => {
    api
      .post("/mypage/checkpwd", {
        userId: JSON.parse(sessionStorage.getItem("userInfo")).userId,
        userPwd: pwd,
      })
      .then((response) => {
        if (
          response.data.token != null &&
          response.data.token.accessToken != null
        ) {
          const prevUserInfo =
            JSON.parse(sessionStorage.getItem("userInfo")) || {};
          const updatedUserInfo = {
            ...prevUserInfo,
            accessToken: response.data.token.accessToken,
          };
          sessionStorage.setItem("userInfo", JSON.stringify(updatedUserInfo));
        }

        if (response.data.isVerified) {
          navigate("/mypage/main");
        } else {
          setIsDialogOpen(true);
        }
      })
      .catch(() => {});
  };

  const handleCancel = () => {
    navigate(-1);
  };

  return (
    <div>
      <BreadCrumbDiv items={[t("L0045")]}></BreadCrumbDiv>

      <ListWrapDiv className={"list_hori"}>
        <table style={{ tableLayout: "fixed" }}>
          <tbody>
            <tr>
              <th>{t("L0039")}</th>
              <td>
                <SearchInput
                  type="password"
                  style={{ border: "0.5px solid lightgray" }}
                  maxLength={250}
                  value={pwd}
                  onChange={handlePwdChange}
                  onKeyDown={activeEnter}
                ></SearchInput>
              </td>
            </tr>
          </tbody>
        </table>

        <ButtonWrapDiv className="btn_bottom">
          <FunctionButton
            className="big"
            color="bg_gray"
            value={t("L0005")}
            onClick={handleCancel}
          ></FunctionButton>
          <FunctionButton
            className="big"
            value={t("L0659")}
            onClick={handleSubmit}
          ></FunctionButton>
        </ButtonWrapDiv>
      </ListWrapDiv>

      {isDialogOpen && (
        <MessageDialog title={"Information"} message={t("L1089")}>
          <FunctionButton
            value={t("L0004")}
            onClick={handleConfirm}
          ></FunctionButton>
        </MessageDialog>
      )}
    </div>
  );
};

export default CheckPwdPage;
